// @flow
import { connect } from 'react-redux';
import DeviceList from './component';
import { getIconLocaleSuffix } from '~/core/state/config/selectors';
import { getIsHubNano1 } from '~/core/state/devices/selectors';
import { groupBy, get } from 'lodash/fp';
import {
    gu10DimmableModelTypes,
    gu10TuneableModelTypes,
    candlelightDimmableModelTypes,
    candlelightTuneableModelTypes
} from '~/core/constants/devices';

const modelTypeGroupMap = model =>
    new Map([
        [true, model],
        [gu10DimmableModelTypes.includes(model), gu10DimmableModelTypes[model]],
        [gu10TuneableModelTypes.includes(model), gu10TuneableModelTypes[model]],
        [candlelightDimmableModelTypes.includes(model), candlelightDimmableModelTypes[model]],
        [candlelightTuneableModelTypes.includes(model), candlelightTuneableModelTypes[model]]
    ]).get(true);

const mapStateToProps = (
    state,
    { devices }
): {
    devices: Array<*>,
    localeSuffix: string
} => ({
    devices: Object.values(groupBy(device => device.type && modelTypeGroupMap(get('model')(device.props)), devices)),
    localeSuffix: getIconLocaleSuffix(state),
    isNano1: getIsHubNano1(state)
});

export default connect(mapStateToProps)(DeviceList);



// WEBPACK FOOTER //
// ./src/components/widgets/device-list/index.js